import {
  Box, Button, Card, CardActionArea, CardContent,
  Icon,
  Paper, Typography,
  useTheme, FormControl,
  InputLabel,
  MenuItem,
  Select,
  Autocomplete,
  CircularProgress,
  TextField,
}
  from "@mui/material";
import Grid from '@mui/material/Grid2';
import { useEffect, useMemo, useState } from "react";
import { FerramentasDaListagem } from "../../shered/components";
import { LayoutBaseDePagina } from "../../shered/layouts/LayoutBaseDePagina";
import { JogadorService } from "../../shered/services/api/jogador/JogadorService";
import { IDadosTodosHistoricosLigaResposta, IListagemLigas, LigaService } from "../../shered/services/api/liga/LigaService";

import { useSearchParams, useNavigate } from "react-router-dom";
import { useAuthContext } from "../../shered/contexts";
import { DialogMensagem, IDadosModal } from "../../shered/components/modal/DialogMensagem";
import { moedaRealLocaleValue } from "../../shered/components/input-valor-moeda/Current-Mask";
import { ILstDrop, TDropOptions, UtilidadeService } from "../../shered/services/api/utilidades/UtilidadesService";
import { IModalDadosDetalheProps, ModalDetalhesProposta } from "../../shered/components/modal/ModalDetalhesProposta";
import dayjs from "dayjs";
import { Loading } from "../../shered/components/loading/Loading";
import { FranquiaService } from "../../shered/services/api/franquia/FranquiaService";
import CookieService from "../../shered/services/autenticacao/CookieService";

export const ListagemDeMovimentacoes: React.FC = () => {
  const user = CookieService.get("access_user");
  const [usuarioComissario, setUsuarioComissario] = useState(false);
  // const theme = useTheme();
  // const [temaSelecionado, setTemaSelecionado] = useState(CookieService.get("access_thema"));
  // const { themeName } = useAppThemeContext();
  // let crypt = UtilidadeService.crypt("0");
  // const { id } = useParams<"id">();
  let codLocal = localStorage.getItem("@codigoLiga");
  const [codigoLiga, setCodigoLiga] = useState(codLocal !== null ? UtilidadeService.decrypt(codLocal) : "0");
  const navigate = useNavigate();
  const [removeLoading, setRemoveLoading] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [nomeLiga, setNomeLiga] = useState("");
  const { logout } = useAuthContext();
  const [logoImage, setLogoImage] = useState("");
  const [dadosLiga, setDadosLiga] = useState<IListagemLigas>();
  const [redirecionar, setRedirecionar] = useState("0");
  const [showModalMensagem, setShowModalMensagem] = useState(false);
  const [showModalDetalheProposta, setShowModalDetalheProposta] = useState(false);
  const [showImagemFranquia, setShowImagemFranquia] = useState<any>("../../semimagemescudo.png");
  const [lstDadosHistorico, setLstDadosHistorico] = useState<IDadosTodosHistoricosLigaResposta[]>([]);
  const [codTemporadaAtual, setCodTemporadaAtual] = useState(0);
  const [selectedIdComplete, setSelectedIdComplete] = useState<number | undefined>(0);
  const [codigoTemporadaFiltro, setCodigoTemporadaFiltro] = useState(0);
  const [opcoesAutoCompleteJogador, setOpcoesAutoCompleteJogador] = useState<TDropOptions[]>([])
  const [lstTemporadas, setLstTemporadas] = useState<ILstDrop[]>([]);
  const [lstFraqnuias, setLstFranquias] = useState<ILstDrop[]>([]);
  const [franquiaFiltro, setFranquiaFiltro] = useState(0);

  const [dadosModal, setDadosModal] = useState<IDadosModal>({
    acao: false,
    label: "",
    tipo: "error",
    mensagem: "Sessão Expirada!",
    display: "none",
    titulo: "Atenção"
  });

  const [dadosModalDetalhesProposta, setDadosModalDetalhesProposta] = useState<IModalDadosDetalheProps>({
    acao: false,
    label: "",
    codigoProposta: 0,
    mensagem: "Sessão Expirada!",
    titulo: "Atenção",
    reverter: false
  });

  const autoCompleteSelectedOption = useMemo(() => {
    if (!selectedIdComplete) return null;

    const selectedOption = opcoesAutoCompleteJogador.find(opcao => opcao.codigo === selectedIdComplete);
    if (!selectedOption) return null;

    return selectedOption;
  }, [selectedIdComplete, opcoesAutoCompleteJogador]);

  const toggleModalMensagem = () => {
    setShowModalMensagem(modalVisivel => !modalVisivel);
    if (redirecionar.length > 1) {
      navigate(redirecionar);
    }
  };

  useEffect(() => {
    if (codigoLiga !== null && codigoLiga !== undefined) {
      const fetchData = async () => {
        setIsLoading(true);
        setRemoveLoading(false);
        UtilidadeService.getTemporadasLiga(Number(codigoLiga))
          .then((result) => {
            const tmps = result.data.dado;
            let lstTemporadasAux = tmps.map((f, i) => ({ codigo: f.codigo, label: f.descricao_Temporada }));
            setLstTemporadas(lstTemporadasAux);
          })
          .catch((errors) => {
            setShowModalMensagem(true);
            if (errors.response !== undefined) {
              if (errors.response.status === 401) {
                setDadosModal({
                  acao: true,
                  label: "",
                  tipo: "info",
                  mensagem: "Sessão expirada!",
                  display: "none",
                  titulo: "Atenção"
                });
                logout();
                setRedirecionar("0");
                return;
              }
              setDadosModal({
                acao: true,
                label: "",
                tipo: "error",
                mensagem: errors.response.data.mensagem,
                display: "none",
                titulo: "Atenção"
              });
              return;
            }

            setDadosModal({
              acao: true,
              label: "",
              tipo: "error",
              mensagem: "Não foi possível carregar os dados. Tente novamente mais tarde. Caso o problema persista, favor entrar em contato com a TI.",
              display: "none",
              titulo: "Atenção"
            });
            return;

          });

        FranquiaService.getByIdLiga(Number(codigoLiga))
          .then((result) => {
            const franquias = result.dado;
            let lstFranquiasAux = franquias.map((f, i) => ({ codigo: f.codigo, label: f.nome }));
            setLstFranquias(lstFranquiasAux);

          })
          .catch((errors) => {
            setShowModalMensagem(true);
            if (errors.response.status === 401) {
              setDadosModal({
                acao: true,
                label: "",
                tipo: "info",
                mensagem: "Sessão expirada!",
                display: "none",
                titulo: "Atenção"
              });
              logout();
              setRedirecionar("0");
              return;
            }
            setDadosModal({
              acao: true,
              label: "",
              tipo: "error",
              mensagem: errors.response.data.mensagem,
              display: "none",
              titulo: "Atenção"
            });
          });

        LigaService.getDadosLigaPeloCodigo(Number(codigoLiga))
          .then((result) => {
            const liga = result.dado;
            setDadosLiga(liga);
            setUsuarioComissario(liga.comissario_Usuario);

            if (liga.caminho_Logo !== null) {
              setShowImagemFranquia(liga.caminho_Logo);
            }
            setCodigoTemporadaFiltro(liga.codigo_Temporada);
          })
          .catch((errors) => {
            setShowModalMensagem(true);
            setRemoveLoading(true);
            if (errors.response !== undefined) {
              if (errors.response.status === 401) {
                setDadosModal({
                  acao: true,
                  label: "",
                  tipo: "info",
                  mensagem: "Sessão expirada!",
                  display: "none",
                  titulo: "Atenção"
                });
                logout();
                setRedirecionar("0");
                return;
              }

              setDadosModal({
                acao: true,
                label: "",
                tipo: "error",
                mensagem: errors.response.data.mensagem,
                display: "none",
                titulo: "Atenção"
              });
              setRedirecionar(`/usuario/liga/${codLocal}`);
              return;
            }
            setDadosModal({
              acao: true,
              label: "",
              tipo: "error",
              mensagem: "Não foi possível carregar os dados. Tente novamente mais tarde. Caso o problema persista, favor entrar em contato com a TI.",
              display: "none",
              titulo: "Atenção"
            });
            return;
          });

        JogadorService.getTodosJogadores(Number(codigoLiga), selectedIdComplete)
          .then((result) => {
            const resultado = result.data.dado;
            let lstDrop: TDropOptions[] = resultado
              .map((f, i) => ({ codigo: f.codigo, label: f.nome, descricao: f.codigo_NBA.toString() }));
            setOpcoesAutoCompleteJogador(lstDrop.sort((a, b) => a.label > b.label ? 1 : -1));

          }).catch((errors) => {
            setIsLoading(false);
            setShowModalMensagem(true);
            setRemoveLoading(true);
            if (errors.response !== undefined) {
              if (errors.response.status === 401) {
                setDadosModal({
                  acao: true,
                  label: "",
                  tipo: "info",
                  mensagem: "Sessão expirada!",
                  display: "none",
                  titulo: "Atenção"
                });

                logout();
                setRedirecionar("0");
                return;
              }
              setDadosModal({
                acao: true,
                label: "",
                tipo: "error",
                mensagem: errors.response.data.mensagem,
                display: "none",
                titulo: "Atenção"
              });
              return;
            }
            else {
              setDadosModal({
                acao: true,
                label: "",
                tipo: "error",
                mensagem: "Não foi possível carregar os dados do jogador! Favor entrar em contato com a TI",
                display: "none",
                titulo: "Atenção"
              });
            }
          });

        setTimeout(() => {
          CarregarDadosMovimentacoes(Number(codigoLiga));
        }, 2000)
      }
      fetchData();
    }
  }, [codigoLiga]);

  const CarregarDadosMovimentacoes = async (codigoLiga: number) => {
    setRemoveLoading(false);
    setIsLoading(true);
    await LigaService.getDadosLigaPeloCodigo(Number(codigoLiga))
      .then((result) => {
        const liga = result.dado;
        setDadosLiga(liga);
        setNomeLiga(liga.nome);
        setLogoImage(liga.caminho_Logo);
        setCodTemporadaAtual(liga.codigo_Temporada);
        localStorage.setItem("@codigoTemp", liga.codigo_Temporada.toString());

      }).catch((errors) => {
        setRedirecionar("0");
      });

    await LigaService.getDadosMovimentacoesPorFiltros(codigoLiga, codigoTemporadaFiltro, franquiaFiltro, selectedIdComplete)
      .then((result) => {

        const lstMovimentacoes = result.dado;
        setLstDadosHistorico(lstMovimentacoes === null ? [] : lstMovimentacoes);
        setRemoveLoading(true);
        setIsLoading(false);
      })
      .catch((errors) => {
        setShowModalMensagem(true);
        setIsLoading(false);
        if (errors.response.status === 401) {
          setDadosModal({
            acao: true,
            label: "",
            tipo: "info",
            mensagem: "Sessão expirada!",
            display: "none",
            titulo: "Atenção"
          });
          logout();
          setRedirecionar("0");
          return;
        }
        setDadosModal({
          acao: true,
          label: "",
          tipo: "error",
          mensagem: errors.response.data.mensagem,
          display: "none",
          titulo: "Atenção"
        });
        return;
      });
  }


  const handleCarregarDetalhesProposta = (codigoProposta: number) => {
    setShowModalDetalheProposta(true);
    setDadosModalDetalhesProposta({
      acao: true,
      label: "",
      mensagem: `Dados da Proposta ${codigoProposta} `,
      codigoProposta: codigoProposta,
      titulo: "Atenção",
      reverter: (usuarioComissario || user.administrador)
    });
  }

  const toggleModalDetalhesProposta = () => {
    setShowModalDetalheProposta(modalVisivel => !modalVisivel);
  };

  const carregaPosicao = (posicao_1: string, posicao_2: string | null, posicao_3: string | null) => {

    let posicoes = `${UtilidadeService.verificaTipoPosicao(posicao_1)} ${posicao_2 !== null ? " | " : ""} ${posicao_2 !== null ? UtilidadeService.verificaTipoPosicao(posicao_2) : ""} ${posicao_3 !== null ? " | " : ""} ${posicao_3 !== null ? UtilidadeService.verificaTipoPosicao(posicao_3) : ""}`;
    //console.log(posicoes);
    let qtd = posicoes.split("|").length;
    let arrImagens = posicoes.split("|");

    let imgs = qtd === 1 ? <img src={arrImagens[0]} alt={"img1"} width={25} height={25} style={{ borderRadius: "50%" }} />
      : qtd === 2 ?
        <>  <img src={arrImagens[0]} alt={"img1"} width={25} height={25} style={{ borderRadius: "50%" }} />
          <img src={arrImagens[1]} alt={"img2"} width={25} height={25} style={{ borderRadius: "50%", marginLeft: 4 }} />
        </>
        : <> <img src={arrImagens[0]} alt={"img1"} width={25} height={25} style={{ borderRadius: "50%" }} />
          <img src={arrImagens[1]} alt={"img2"} width={25} height={25} style={{ borderRadius: "50%", marginLeft: 4 }} />
          <img src={arrImagens[2]} alt={"img3"} width={25} height={25} style={{ borderRadius: "50%", marginLeft: 4 }} />
        </>

    return imgs
  }

  const handleSelectedFranquia = async (e: { target: { name: string; value: any; }; }) => {
    setFranquiaFiltro(Number(e.target.value));
    setCodigoTemporadaFiltro(codigoTemporadaFiltro);
  }

  return (
    <LayoutBaseDePagina
      titulo={`MOVIMENTAÇÕES ${nomeLiga.toUpperCase()}`}
      showLogoImg={logoImage}
      barraDeFerramentas={<FerramentasDaListagem
        mostrarBotaoNovo={false}
        mostrarBotaoVoltar={false}
        aoClicarEmVoltar={() => { navigate(-1) }}

      />}
    >
      {showModalMensagem && <DialogMensagem dados={dadosModal} isModalVisible={showModalMensagem} onBackClickClose={toggleModalMensagem} />}
      {showModalDetalheProposta && <ModalDetalhesProposta dados={dadosModalDetalhesProposta} isModalVisible={showModalDetalheProposta} onBackClickClose={toggleModalDetalhesProposta} />}
      <Box margin={1} display="flex" flexDirection="column" component={Paper} variant="outlined">
        <Grid container direction="column" padding={2} spacing={3}>
          <Grid container spacing={2}>
            <Grid size={{ xs: 12, sm: 12 }} padding={2}>
              <Typography style={{ fontSize: UtilidadeService.isMobile() ? 14 : "1.25rem" }}>
                Histórico de Movimentações
              </Typography>
              <hr />
            </Grid>

            <Grid container size={{ xs: 12, sm: 12 }} display="flex" justifyContent="initial" spacing={2}>
              <Grid size={{ xs: 12, sm: 3, md: 3 }} display="flex" justifyContent="center">
                <FormControl fullWidth disabled={isLoading}>
                  <InputLabel id="demo-simple-select-label">Temporada</InputLabel>
                  <Select
                    variant="outlined"
                    native={false}
                    value={codigoTemporadaFiltro}
                    label="Temporada"
                    defaultValue={codigoTemporadaFiltro}
                    onChange={(e) => setCodigoTemporadaFiltro(Number(e.target.value))}                                        >
                    {/* <MenuItem value={0}>Selecione</MenuItem> */}
                    {
                      lstTemporadas.map(item => (<MenuItem key={item.codigo} value={item.codigo}>{item.label}</MenuItem>))
                    }
                  </Select>
                </FormControl >
              </Grid>
              <Grid size={{ xs: 12, sm: 6, md: 3 }} >
                <FormControl fullWidth disabled={isLoading}>
                  <InputLabel id="demo-simple-select-label">Franquia</InputLabel>
                  <Select
                    variant="outlined"
                    native={false}
                    value={franquiaFiltro}
                    label="Franquia"
                    onChange={handleSelectedFranquia}
                  >
                    <MenuItem value={0}>Selecione</MenuItem>
                    {
                      lstFraqnuias.map(item => (<MenuItem key={item.codigo} value={item.codigo}>{item.label}</MenuItem>))
                    }
                  </Select>
                </FormControl >
              </Grid>
              <Grid size={{ xs: 12, sm: 6, md: 3 }} >
                <Autocomplete
                  openText="Abrir"
                  closeText="Fechar"
                  noOptionsText="Sem opções"
                  loadingText="Carregando..."
                  disablePortal
                  options={opcoesAutoCompleteJogador}
                  loading={isLoading}
                  disabled={isLoading}
                  value={autoCompleteSelectedOption}
                  size={UtilidadeService.isMobile() ? "small" : "medium"}
                  onChange={(event, newValue) => { setSelectedIdComplete(newValue?.codigo); }}
                  popupIcon={isLoading ? <CircularProgress size={UtilidadeService.isMobile() ? 16 : 28} /> : undefined}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Jogador"
                      slotProps={{
                        inputLabel: {
                          style: {
                            fontSize: UtilidadeService.isMobile() ? 13 : 16
                          }
                        }
                      }}
                    />
                  )}
                />
              </Grid>
              <Grid size={{ xs: 6, sm: 2, md: 2 }} display={"flex"} justifyContent={"end"} alignSelf={"center"}>
                <Button
                  color="primary"
                  variant="contained"
                  disableElevation
                  onClick={() => CarregarDadosMovimentacoes(Number(codigoLiga))}
                  startIcon={<Icon>change_circle</Icon>}
                >
                  Pesquisar
                </Button>
              </Grid>
            </Grid>
            <Grid size={{ xs: 12, sm: 12 }}>
              {isLoading && !removeLoading && <Loading />}
            </Grid>
            <Grid size={{ xs: 12, sm: 12 }}>
              <hr />
            </Grid>
            {!isLoading && lstDadosHistorico.length > 0 ?
              (
                <Grid container size={{ xs: 12, sm: 12 }}>
                  {
                    UtilidadeService.isMobile() ?
                      (<Grid container spacing={2} marginBottom={2} display={!removeLoading ? "none" : "flex"}>
                        {
                          lstDadosHistorico
                            .sort((a, b) => Number(new Date(b.data_Historico)) - Number(new Date(a.data_Historico)))
                            .map((hist, i) => (
                              hist.codigo_Tipo_Historico === 1 ? //Free Agency
                                (
                                  <Grid key={`FA ${hist.free_Agency_Lance.codigo}`} container size={{ xs: 12, sm: 12, md: 12 }}   >
                                    <Card key={`Card ${hist.free_Agency_Lance.codigo}`} >
                                      <CardActionArea>
                                        <CardContent sx={{ padding: 1 }} >
                                          <Grid container size={{ xs: 12, sm: 12, md: 12 }} paddingTop={0}>
                                            <Grid size={{ xs: 12, sm: 12, md: 2 }} display="flex" alignSelf="center">
                                              <Grid size={{ xs: 3, sm: 3 }} display="flex" padding={1} >
                                                <img src={hist.free_Agency_Lance.logo_Franquia !== "https://bskt.mudfaz.com.br:82/Files/Images/Franquia/Logo/" ? hist.free_Agency_Lance.logo_Franquia : showImagemFranquia} alt={hist.free_Agency_Lance.nome_Franquia} width={UtilidadeService.isMobile() ? 40 : 80} height={UtilidadeService.isMobile() ? 40 : 80} />
                                              </Grid>
                                              <Grid size={{ xs: 6, sm: 6 }} display="flex" justifyContent="center" flexDirection="column">
                                                <Typography variant="body2" sx={{ paddingLeft: "10px", fontWeight: "bold" }} display="flex" alignSelf="start">
                                                  {new Date(hist.free_Agency_Lance.data_Fim_Lance).toLocaleDateString("pt-Br")} {new Date(hist.free_Agency_Lance.data_Fim_Lance).toLocaleTimeString("pt-Br")}
                                                </Typography>
                                                <Typography variant="body2" sx={{ paddingLeft: "10px" }} display="flex" alignSelf="center">
                                                  <span style={{ fontWeight: "bold" }}>Free Agency  </span>
                                                </Typography>
                                              </Grid>
                                              <Grid size={{ xs: 3, sm: 3 }} display="flex" padding={1} >
                                                <Typography variant="body2" sx={{ paddingLeft: "10px" }} display="flex" alignSelf="center">
                                                  <img src={hist.free_Agency_Lance.foto_Jogador} alt={hist.free_Agency_Lance.nome_Jogador} width={UtilidadeService.isMobile() ? 50 : 50} height={UtilidadeService.isMobile() ? 45 : 50}
                                                    onError={({ currentTarget }) => {
                                                      currentTarget.onerror = null;
                                                      currentTarget.src = "../../../../semimagem.png";
                                                      currentTarget.style.borderRadius = "50%";
                                                      currentTarget.style.width = UtilidadeService.isMobile() ? "30px" : "40px";
                                                      currentTarget.style.height = UtilidadeService.isMobile() ? "30px" : "40px";
                                                    }}
                                                  />
                                                </Typography>
                                              </Grid>
                                            </Grid>
                                          </Grid>
                                          <Grid paddingTop={1}>
                                            <Box width="100%" display="flex" flexDirection="row" justifySelf="center" alignSelf="center">
                                              <Grid display="flex" justifyContent="start" flexDirection="column">
                                                <Typography variant="body2" sx={{ paddingLeft: "10px", fontSize: 13 }}>
                                                  A franquia <span style={{ fontWeight: "bold" }}>{hist.free_Agency_Lance.nome_Franquia}</span> contratou o jogador {hist.free_Agency_Lance.nome_Jogador} com o salário R${moedaRealLocaleValue(hist.free_Agency_Lance.valor)} / {hist.free_Agency_Lance.tempo_Contrato}
                                                </Typography>
                                              </Grid>

                                            </Box>
                                          </Grid>
                                        </CardContent>
                                      </CardActionArea>
                                    </Card>
                                  </Grid>
                                )
                                : hist.codigo_Tipo_Historico === 2 ? //Leilao
                                  (
                                    <Grid key={`Leilao ${hist.leilao_Lance.codigo}`} size={{ xs: 12, sm: 12, md: 12 }} >
                                      <Card key={"Card" + i} >
                                        <CardActionArea onClick={() => { handleCarregarDetalhesProposta(Number(hist.leilao_Lance.codigo)); setShowModalDetalheProposta(true); }}>
                                          <CardContent sx={{ padding: 1, paddingBottom: 1 }} >
                                            <Grid container size={{ xs: 12, sm: 12, md: 12 }} paddingTop={0}>
                                              <Grid size={{ xs: 12, sm: 12, md: 2 }} display="flex" alignSelf="center">
                                                <Grid size={{ xs: 3, sm: 3 }} display="flex" padding={1} >
                                                  <img src={hist.leilao_Lance.foto_Jogador === null ? showImagemFranquia : hist.leilao_Lance.foto_Jogador}
                                                    alt={hist.leilao_Lance.nome_Jogador}
                                                    width={70}
                                                    height={70}
                                                    style={{ borderRadius: "20%" }}
                                                    onError={({ currentTarget }) => {
                                                      currentTarget.onerror = null;
                                                      currentTarget.src = "../../../../semimagem.png";
                                                      currentTarget.style.borderRadius = "50%";
                                                      currentTarget.style.width = UtilidadeService.isMobile() ? "30px" : "40px";
                                                      currentTarget.style.height = UtilidadeService.isMobile() ? "30px" : "40px";
                                                    }}
                                                  />
                                                </Grid>
                                                <Grid size={{ xs: 6, sm: 6 }} display="flex" justifyContent="center" flexDirection="column">
                                                  <Typography variant="body2" sx={{ paddingLeft: "10px", fontWeight: "bold" }} display="flex" alignSelf="start">
                                                    {new Date(hist.leilao_Lance.data_Fim_Lance).toLocaleDateString("pt-Br")} {new Date(hist.leilao_Lance.data_Fim_Lance).toLocaleTimeString("pt-Br")}
                                                  </Typography>
                                                  <Typography variant="body2" display="flex" justifyContent="center">
                                                    <span style={{ fontWeight: "bold" }}>LEILÃO </span>
                                                  </Typography>
                                                </Grid>
                                                <Grid size={{ xs: 3, sm: 3 }} display="flex" justifyContent="center" alignSelf={"center"} padding={1} >
                                                  {carregaPosicao(hist.leilao_Lance.posicao_Jogador, null, null)}
                                                </Grid>
                                              </Grid>
                                            </Grid>
                                            <Grid paddingTop={1}>
                                              <Box width="100%" minHeight="80px">
                                                <Grid container paddingRight={3} size={{ xs: 12, sm: 12 }} display="flex" flexDirection="row" justifyItems="start" >
                                                  <Grid size={{ xs: 12, sm: 12 }}>
                                                    <Typography variant="body2" sx={{ paddingLeft: "10px", fontSize: 13 }}>
                                                      Rodada {hist.leilao_Lance.rodada} - {hist.leilao_Lance.irregular ? <span style={{ color: "red" }}> IRREGULAR </span> : null} - {hist.leilao_Lance.nome_Franquia} venceu o leilão do jogador  <span style={{ fontWeight: "bold" }}>{hist.leilao_Lance.nome_Jogador} </span> com o valor de <span style={{ fontWeight: "bold" }}>R$ {moedaRealLocaleValue(hist.leilao_Lance.valor)}</span>
                                                    </Typography>
                                                  </Grid>
                                                </Grid>
                                              </Box>
                                            </Grid>
                                          </CardContent>
                                        </CardActionArea>
                                      </Card>
                                    </Grid>
                                  )
                                  : hist.codigo_Tipo_Historico === 3 ? //Proposta
                                    (
                                      <Grid key={`Proposta ${hist.proposta.codigo}`} size={{ xs: 12, sm: 12, md: 12 }}   >
                                        <Card key={"Card" + i} >
                                          <CardActionArea onClick={() => { handleCarregarDetalhesProposta(Number(hist.proposta.codigo)); setShowModalDetalheProposta(true); }}>
                                            <CardContent sx={{ padding: 1, paddingBottom: 1 }} >
                                              <Grid container size={{ xs: 12, sm: 12, md: 12 }} display="flex" direction="row">
                                                <Grid container size={{ xs: 12, sm: 12, md: 12 }} display="flex" alignSelf="center">
                                                  <Grid container display="flex" direction="row" size={{ xs: 12, sm: 12 }} justifyContent="center" >
                                                    <Grid display="flex" alignSelf="initial" justifyContent="start" >
                                                      <Typography variant="body2" >
                                                        <span style={{ fontWeight: "bold" }}>{dayjs(hist.proposta.data_Hora_Expira).format('DD/MM/YYYY HH:mm')} </span>
                                                      </Typography>
                                                    </Grid>
                                                  </Grid>
                                                  <Grid container display="flex" direction="row" size={{ xs: 12, sm: 12 }} justifyContent="center" >
                                                    {hist.proposta.franquias.map(f =>
                                                    (
                                                      <Grid display="flex" padding={1} >
                                                        <img src={f.logo === null ? showImagemFranquia : f.logo}
                                                          alt={f.nome}
                                                          width={50}
                                                          height={50}
                                                        />
                                                      </Grid>
                                                    ))}
                                                  </Grid>
                                                </Grid>
                                                <Grid display="flex" size={{ xs: 12, sm: 12, md: 12 }} flexDirection="row" justifySelf="start" >
                                                  <Box width="100%" minHeight="80px">
                                                    <Grid container paddingRight={3} size={{ xs: 12, sm: 12 }} display="flex" flexDirection="row" justifyItems="start" >
                                                      <Grid display="flex" alignSelf="center">
                                                        <Typography variant="body1" >
                                                          <span style={{ fontWeight: "bold" }}>Trocas: </span>
                                                        </Typography>
                                                      </Grid>
                                                      <Grid paddingLeft={1} >
                                                        {hist.proposta.dados_Proposta.sort((a, b) => a.nome_Franquia_Recebe.trim() > b.nome_Franquia_Recebe.trim() ? 1 : -1).map(p => (
                                                          <Grid display="flex" alignSelf="center">
                                                            <Typography variant="body2" style={{ fontSize: 13 }} >
                                                              <span style={{ fontWeight: "bold" }}>- {p.nome_Franquia_Recebe} recebe: </span>
                                                              {p.tipo_Ativo === 1 || p.tipo_Ativo === 2 ? ` ${p.nome_Jogador} de ${p.nome_Franquia_Envia} `
                                                                : p.tipo_Ativo === 3 && (p.valor_Multa_Quebrada === undefined || p.valor_Multa_Quebrada === null) ? `multa de valor R$${moedaRealLocaleValue(p.valor_Multa !== undefined ? p.valor_Multa : "0")} de ${p.nome_Franquia_Envia}`
                                                                  : p.tipo_Ativo === 3 && p.valor_Multa_Quebrada !== undefined && p.valor_Multa_Quebrada !== null ? `multa de valor R$${moedaRealLocaleValue(p.valor_Multa_Quebrada !== undefined ? p.valor_Multa_Quebrada : "0")} de ${p.nome_Franquia_Envia}`
                                                                    : p.tipo_Ativo === 5 ? p.posicao_Final !== undefined && p.posicao_Final > 2 ? ` Pick Protegida ${p.posicao_Final} temporada ${p.ano_Pick} de ${p.nome_Franquia_Origem_Pick}`
                                                                      : ` Pick Protegida ${p.rodada_Pick !== undefined ? p.rodada_Pick === 1 ? " First" : p.rodada_Pick === 2 ? ` Second ` : p.rodada_Pick + "º " : ""} Pick Protegida ${p.ano_Pick} de ${p.nome_Franquia_Origem_Pick}`
                                                                      : p.tipo_Ativo === 6 ? p.posicao_Final !== undefined && p.posicao_Final > 2 ? ` Swap ${p.posicao_Final} temporada ${p.ano_Pick} de ${p.nome_Franquia_Origem_Pick}`
                                                                        : ` Swap ${p.rodada_Pick !== undefined ? p.rodada_Pick === 1 ? " First" : p.rodada_Pick === 2 ? ` Second ` : p.rodada_Pick + "º " : ""} Swap ${p.ano_Pick} de ${p.nome_Franquia_Origem_Pick}`
                                                                        : p.posicao_Final !== undefined && p.posicao_Final > 2 ? ` Pick ${p.posicao_Final} temporada ${p.ano_Pick} de ${p.nome_Franquia_Origem_Pick}`
                                                                          : ` Pick ${p.rodada_Pick !== undefined
                                                                            ? p.rodada_Pick === 1 ? " First" :
                                                                              p.rodada_Pick === 2 ? " Second "
                                                                                : p.rodada_Pick + "º "
                                                                            : ""} ${p.ano_Pick} de ${p.nome_Franquia_Origem_Pick}`}
                                                            </Typography>
                                                          </Grid>
                                                        ))}
                                                      </Grid>
                                                    </Grid>
                                                  </Box>
                                                </Grid>
                                              </Grid>
                                            </CardContent>
                                          </CardActionArea>
                                        </Card>
                                      </Grid>
                                    )
                                    : hist.codigo_Tipo_Historico === 4 && //Dispensa
                                    (
                                      <Grid key={`Dispensa ${hist.dispensa.codigo}${i}`} size={{ xs: 12, sm: 12, md: 12 }} >
                                        <Card key={"Card" + i} >
                                          {/* <CardActionArea> */}
                                          <CardContent sx={{ padding: 1 }} style={{ paddingBottom: "13px" }} >
                                            <Grid container size={{ xs: 12, sm: 12, md: 12 }} display="flex" direction="row">
                                              <Grid container size={{ xs: 12, sm: 12, md: 2 }} display="flex" alignSelf="center">

                                                <Grid size={{ xs: 3, sm: 3 }} display="flex" padding={1} >
                                                  <img src={hist.dispensa.foto === null ? showImagemFranquia : hist.dispensa.foto}
                                                    alt={hist.dispensa.nome}
                                                    width={UtilidadeService.isMobile() ? 50 : 80}
                                                    height={UtilidadeService.isMobile() ? 50 : 80}
                                                    style={{ borderRadius: "20%" }}
                                                    onError={({ currentTarget }) => {
                                                      currentTarget.onerror = null;
                                                      currentTarget.src = "../../../../semimagem.png";
                                                      currentTarget.style.borderRadius = "50%";
                                                      currentTarget.style.width = UtilidadeService.isMobile() ? "30px" : "40px";
                                                      currentTarget.style.height = UtilidadeService.isMobile() ? "30px" : "40px";
                                                    }}
                                                  />
                                                </Grid>
                                                <Grid size={{ xs: 6, sm: 6 }} display="flex" flexDirection="column" alignSelf="center" justifyContent={"center"}>
                                                  <Typography variant="body2" sx={{ paddingLeft: "10px", fontWeight: "bold" }} display="flex" alignSelf="start">
                                                    {new Date(hist.dispensa.data_Saida_Franquia).toLocaleDateString("pt-Br")} {new Date(hist.dispensa.data_Saida_Franquia).toLocaleTimeString("pt-Br")}
                                                  </Typography>
                                                  <Typography variant="body2" display="flex" justifyContent={"center"}>
                                                    <span style={{ fontWeight: "bold", color: "red" }}>DISPENSA </span>
                                                  </Typography>
                                                </Grid>
                                                <Grid size={{ xs: 3, sm: 3 }} display="flex" paddingLeft={2} alignSelf="center" >
                                                  <img src={hist.dispensa.logo_Franquia === null ? showImagemFranquia : hist.dispensa.logo_Franquia}
                                                    alt={hist.dispensa.nome_Franquia}
                                                    width={UtilidadeService.isMobile() ? 50 : 80}
                                                    height={UtilidadeService.isMobile() ? 50 : 80}
                                                  />
                                                </Grid>
                                              </Grid>
                                              <Grid display="flex" size={{ xs: 12, sm: 12, md: 10 }} paddingTop={1} >
                                                <Box width="100%" minHeight="50px">
                                                  <Grid container paddingRight={3} size={{ xs: 12, sm: 12 }} display="flex">
                                                    <Typography variant="body2" style={{ fontSize: 13 }}>
                                                      O jogador  <span style={{ fontWeight: "bold" }}>{hist.dispensa.nome} </span> foi dispensado pela franquia <span style={{ fontWeight: "bold" }}>{hist.dispensa.nome_Franquia}</span>
                                                    </Typography>
                                                  </Grid>
                                                </Box>
                                              </Grid>
                                            </Grid>
                                          </CardContent>
                                        </Card>
                                      </Grid>
                                    )
                            ))
                        }
                      </Grid>)
                      :
                      (
                        <Grid container spacing={2} marginBottom={2} display={!removeLoading ? "none" : "flex"}>
                          {
                            lstDadosHistorico
                              .sort((a, b) => Number(new Date(b.data_Historico)) - Number(new Date(a.data_Historico)))
                              .map((hist, i) => (
                                hist.codigo_Tipo_Historico === 1 ? //Free Agency
                                  (
                                    <Grid key={`FA ${hist.free_Agency_Lance.codigo}`} size={{ xs: 12, sm: 12, md: 12 }}  >
                                      <Card key={`Card ${hist.free_Agency_Lance.codigo}`} >
                                        <CardActionArea>
                                          <CardContent sx={{ padding: 1 }} >
                                            <Grid paddingTop={0}>
                                              <Box width="100%" display="flex" flexDirection="row" justifySelf="center" alignSelf="center">
                                                <img src={hist.free_Agency_Lance.logo_Franquia !== "https://bskt.mudfaz.com.br:82/Files/Images/Franquia/Logo/" ? hist.free_Agency_Lance.logo_Franquia : showImagemFranquia} alt={hist.free_Agency_Lance.nome_Franquia} width={80} height={80} />
                                                <Grid display="flex" justifyContent="start" flexDirection="column">
                                                  <Typography variant="body2" sx={{ paddingLeft: "10px", fontWeight: "bold" }} display="flex" alignSelf="start">
                                                    {new Date(hist.free_Agency_Lance.data_Fim_Lance).toLocaleDateString("pt-Br")} {new Date(hist.free_Agency_Lance.data_Fim_Lance).toLocaleTimeString("pt-Br")}
                                                  </Typography>
                                                  <Typography variant="body2" sx={{ paddingLeft: "10px" }} display="flex" alignSelf="center">
                                                    <span style={{ fontWeight: "bold" }}>Free Agency - </span> A franquia {hist.free_Agency_Lance.nome_Franquia} contratou o jogador {hist.free_Agency_Lance.nome_Jogador} com o salário R${moedaRealLocaleValue(hist.free_Agency_Lance.valor)} / {hist.free_Agency_Lance.tempo_Contrato}
                                                  </Typography>
                                                </Grid>
                                                <Typography variant="body2" sx={{ paddingLeft: "10px" }} display="flex" alignSelf="center">
                                                  <img src={hist.free_Agency_Lance.foto_Jogador} alt={hist.free_Agency_Lance.nome_Jogador} width={50} height={50}
                                                    onError={({ currentTarget }) => {
                                                      currentTarget.onerror = null;
                                                      currentTarget.src = "../../../../semimagem.png";
                                                      currentTarget.style.borderRadius = "50%";
                                                      currentTarget.style.width = UtilidadeService.isMobile() ? "30px" : "40px";
                                                      currentTarget.style.height = UtilidadeService.isMobile() ? "30px" : "40px";
                                                    }}
                                                  />
                                                </Typography>
                                              </Box>
                                            </Grid>
                                          </CardContent>
                                        </CardActionArea>
                                      </Card>
                                    </Grid>
                                  )
                                  : hist.codigo_Tipo_Historico === 2 ? //Leilao
                                    (
                                      <Grid key={`Leilao ${hist.leilao_Lance.codigo}`} size={{ xs: 12, sm: 12, md: 12 }} >
                                        <Card key={"Card" + i} >
                                          <CardActionArea onClick={() => { handleCarregarDetalhesProposta(Number(hist.leilao_Lance.codigo)); setShowModalDetalheProposta(true); }}>
                                            <CardContent sx={{ padding: 1, paddingBottom: 1 }} >
                                              <Grid container size={{ xs: 12, sm: 12, md: 12 }} display="flex" direction="row">
                                                <Grid container width="25%" display="flex" alignSelf="center">
                                                  <Grid container display="flex" direction="column" size={{ xs: 12, sm: 12 }} justifyContent="center" >
                                                    <Grid display="flex" padding={1} >
                                                      <img src={hist.leilao_Lance.foto_Jogador === null ? showImagemFranquia : hist.leilao_Lance.foto_Jogador}
                                                        alt={hist.leilao_Lance.nome_Jogador}
                                                        width={70}
                                                        height={70}
                                                        style={{ borderRadius: "20%" }}
                                                        onError={({ currentTarget }) => {
                                                          currentTarget.onerror = null;
                                                          currentTarget.src = "../../../../semimagem.png";
                                                          currentTarget.style.borderRadius = "50%";
                                                          currentTarget.style.width = UtilidadeService.isMobile() ? "30px" : "40px";
                                                          currentTarget.style.height = UtilidadeService.isMobile() ? "30px" : "40px";
                                                        }}
                                                      />
                                                      <Grid display="flex" alignSelf="end" paddingLeft={1} size={{ xs: 12, sm: 2 }} >
                                                        {carregaPosicao(hist.leilao_Lance.posicao_Jogador, null, null)}
                                                      </Grid>
                                                    </Grid>
                                                  </Grid>
                                                </Grid>
                                                <Grid display="flex" width="75%" flexDirection="row" justifySelf="start" >
                                                  <Box width="100%" minHeight="80px">
                                                    <Grid container paddingRight={3} size={{ xs: 12, sm: 12 }} display="flex" flexDirection="row" justifyItems="start" >
                                                      <Grid size={{ xs: 12, sm: 12 }}>
                                                        <Typography variant="body2" sx={{ paddingLeft: "10px", fontWeight: "bold" }} display="flex" alignSelf="start">
                                                          {new Date(hist.leilao_Lance.data_Fim_Lance).toLocaleDateString("pt-Br")} {new Date(hist.leilao_Lance.data_Fim_Lance).toLocaleTimeString("pt-Br")}
                                                        </Typography>
                                                      </Grid>
                                                      <Grid  >
                                                        <Typography variant="body2" >
                                                          <span style={{ fontWeight: "bold" }}>Leilão: </span>
                                                        </Typography>
                                                      </Grid>
                                                      <Grid paddingLeft={1} >
                                                        <Grid  >
                                                          <Typography variant="body2" >
                                                            Rodada {hist.leilao_Lance.rodada} - {hist.leilao_Lance.irregular ? <span style={{ color: "red" }}> IRREGULAR </span> : null} - {hist.leilao_Lance.nome_Franquia} venceu o leilão do jogador  <span style={{ fontWeight: "bold" }}>{hist.leilao_Lance.nome_Jogador} </span> com o valor de <span style={{ fontWeight: "bold" }}>R$ {moedaRealLocaleValue(hist.leilao_Lance.valor)}</span>

                                                          </Typography>
                                                        </Grid>
                                                      </Grid>
                                                    </Grid>
                                                  </Box>
                                                </Grid>
                                              </Grid>
                                            </CardContent>
                                          </CardActionArea>
                                        </Card>
                                      </Grid>
                                    )
                                    : hist.codigo_Tipo_Historico === 3 ? //Proposta
                                      (
                                        <Grid key={`Proposta ${hist.proposta.codigo}`} size={{ xs: 12, sm: 12, md: 12 }}   >

                                          <Card key={"Card" + i} >
                                            <CardActionArea onClick={() => { handleCarregarDetalhesProposta(Number(hist.proposta.codigo)); setShowModalDetalheProposta(true); }}>
                                              <CardContent sx={{ padding: 1, paddingBottom: 1 }} >
                                                <Grid container size={{ xs: 12, sm: 12, md: 12 }} display="flex" direction="row">
                                                  <Grid container width="25%" display="flex" alignSelf="center">
                                                    <Grid container display="flex" direction="row" size={{ xs: 12, sm: 12 }} justifyContent="center" >
                                                      <Grid display="flex" alignSelf="initial" justifyContent="start" >
                                                        <Typography variant="body2" >
                                                          <span style={{ fontWeight: "bold" }}>{dayjs(hist.proposta.data_Hora_Expira).format('DD/MM/YYYY HH:mm')} </span>
                                                        </Typography>
                                                      </Grid>
                                                    </Grid>
                                                    <Grid container display="flex" direction="row" size={{ xs: 12, sm: 12 }} justifyContent="center" >
                                                      {hist.proposta.franquias.map(f =>
                                                      (
                                                        <Grid display="flex" padding={1} >
                                                          <img src={f.logo === null ? showImagemFranquia : f.logo}
                                                            alt={f.nome}
                                                            width={50}
                                                            height={50}
                                                          />
                                                        </Grid>
                                                      ))}
                                                    </Grid>
                                                  </Grid>
                                                  <Grid display="flex" width="75%" flexDirection="row" justifySelf="start" >
                                                    <Box width="100%" minHeight="80px">
                                                      <Grid container paddingRight={3} size={{ xs: 12, sm: 12 }} display="flex" flexDirection="row" justifyItems="start" >
                                                        <Grid display="flex" alignSelf="center">
                                                          <Typography variant="body1" >
                                                            <span style={{ fontWeight: "bold" }}>Trocas: </span>
                                                          </Typography>
                                                        </Grid>
                                                        <Grid paddingLeft={1} >
                                                          {hist.proposta.dados_Proposta.sort((a, b) => a.nome_Franquia_Recebe.trim() > b.nome_Franquia_Recebe.trim() ? 1 : -1).map(p => (
                                                            <Grid display="flex" alignSelf="center">
                                                              <Typography variant="body2" >
                                                                - {p.nome_Franquia_Recebe} recebe:
                                                                {p.tipo_Ativo === 1 || p.tipo_Ativo === 2 ? `${p.nome_Jogador} de ${p.nome_Franquia_Envia} `
                                                                  : p.tipo_Ativo === 3 && (p.valor_Multa_Quebrada === undefined || p.valor_Multa_Quebrada === null) ? `multa de valor R$${moedaRealLocaleValue(p.valor_Multa !== undefined ? p.valor_Multa : "0")} de ${p.nome_Franquia_Envia}`
                                                                    : p.tipo_Ativo === 3 && p.valor_Multa_Quebrada !== undefined && p.valor_Multa_Quebrada !== null ? `multa de valor R$${moedaRealLocaleValue(p.valor_Multa_Quebrada !== undefined ? p.valor_Multa_Quebrada : "0")} de ${p.nome_Franquia_Envia}`
                                                                      : p.tipo_Ativo === 5 ? `Pick ${p.rodada_Pick !== null && p.rodada_Pick !== undefined ? p.rodada_Pick === 1 ? " First" : p.rodada_Pick === 2 ? ` Second ` : p.rodada_Pick + "º " : ""} - ${p.ano_Pick} de ${p.nome_Franquia_Origem_Pick}
                                                                        - Pick Protegida (${p.inicio_Protecao} - ${p.fim_Protecao}) ${p.posicao_Final_Protecao !== null ? p.posicao_Final_Protecao : ""} temporada ${p.ano_Pick_Protecao} de ${p.nome_Franquia_Origem_Pick_Protecao}`

                                                                        : p.tipo_Ativo === 6 ? ` Pick ${p.rodada_Pick !== null && p.rodada_Pick !== undefined ? p.rodada_Pick === 1 ? " First" : p.rodada_Pick === 2 ? ` Second ` : p.rodada_Pick + "º " : ""} -  ${p.ano_Pick} de ${p.nome_Franquia_Origem_Pick}                                                                                                                                                     
                                                                                                                                                    - Swap ${p.posicao_Final_Swap !== null ? p.posicao_Final_Swap : ""} temporada ${p.ano_Pick_Swap} de ${p.nome_Franquia_Origem_Pick_Swap}
                                                                                                                                                    - Pick Protegida (${p.inicio_Protecao} - ${p.fim_Protecao}) ${p.posicao_Final_Protecao !== null ? p.posicao_Final_Protecao : ""} temporada ${p.ano_Pick_Protecao} de ${p.nome_Franquia_Origem_Pick_Protecao}`

                                                                          : p.posicao_Final !== undefined && p.posicao_Final > 2 ? ` Pick ${p.posicao_Final} temporada ${p.ano_Pick} de ${p.nome_Franquia_Origem_Pick}`
                                                                            : ` Pick ${p.rodada_Pick !== undefined
                                                                              ? p.rodada_Pick === 1 ? " First" :
                                                                                p.rodada_Pick === 2 ? ` Second `
                                                                                  : p.rodada_Pick + "º "
                                                                              : ""} ${p.ano_Pick} de ${p.nome_Franquia_Origem_Pick}`}
                                                              </Typography>
                                                            </Grid>
                                                          ))}
                                                        </Grid>
                                                      </Grid>
                                                    </Box>
                                                  </Grid>
                                                </Grid>
                                              </CardContent>
                                            </CardActionArea>
                                          </Card>
                                        </Grid>
                                      )
                                      : hist.codigo_Tipo_Historico === 4 && //Dispensa
                                      (
                                        <Grid key={`Dispensa ${hist.dispensa.codigo}${i}`} size={{ xs: 12, sm: 12, md: 12 }} >
                                          <Card key={"Card" + i} >
                                            {/* <CardActionArea> */}
                                            <CardContent sx={{ padding: 1 }} style={{ paddingBottom: "13px" }} >
                                              <Grid container size={{ xs: 12, sm: 12, md: 12 }} display="flex" direction="row">
                                                <Grid container size={{ xs: 12, sm: 12, md: 2 }} display="flex" alignSelf="center">
                                                  <Grid container display="flex" direction="column" size={{ xs: 12, sm: 12 }} justifyContent="center" >
                                                    <Grid display="flex" padding={1} >
                                                      <img src={hist.dispensa.foto === null ? showImagemFranquia : hist.dispensa.foto}
                                                        alt={hist.dispensa.nome}
                                                        width={80}
                                                        height={80}
                                                        style={{ borderRadius: "20%" }}
                                                        onError={({ currentTarget }) => {
                                                          currentTarget.onerror = null;
                                                          currentTarget.src = "../../../../semimagem.png";
                                                          currentTarget.style.borderRadius = "50%";
                                                          currentTarget.style.width = UtilidadeService.isMobile() ? "30px" : "40px";
                                                          currentTarget.style.height = UtilidadeService.isMobile() ? "30px" : "40px";
                                                        }}
                                                      />
                                                    </Grid>
                                                  </Grid>
                                                </Grid>
                                                <Grid display="flex" size={{ xs: 12, sm: 12, md: 10 }} flexDirection="row" justifySelf="start" >
                                                  <Box width="100%" minHeight="80px">
                                                    <Grid container paddingRight={3} size={{ xs: 12, sm: 12 }} display="flex" flexDirection="row" justifyItems="start" >
                                                      <Grid size={{ xs: 12, sm: 12 }}>
                                                        <Typography variant="body2" sx={{ paddingLeft: "10px", fontWeight: "bold" }} display="flex" alignSelf="start">
                                                          {new Date(hist.dispensa.data_Saida_Franquia).toLocaleDateString("pt-Br")} {new Date(hist.dispensa.data_Saida_Franquia).toLocaleTimeString("pt-Br")}
                                                        </Typography>
                                                      </Grid>
                                                      <Grid size={{ xs: 12, sm: 12 }} display="flex" flexDirection="row">
                                                        <Grid  >
                                                          <Typography variant="body2" >
                                                            <span style={{ fontWeight: "bold", color: "red" }}>Dispensa: </span>
                                                          </Typography>
                                                        </Grid>
                                                        <Grid paddingLeft={1} >
                                                          <Grid  >
                                                            <Typography variant="body2" >
                                                              O jogador  <span style={{ fontWeight: "bold" }}>{hist.dispensa.nome} </span> foi dispensado pela franquia <span style={{ fontWeight: "bold" }}>{hist.dispensa.nome_Franquia}</span>
                                                            </Typography>
                                                          </Grid>
                                                        </Grid>
                                                        <Grid display="flex" paddingLeft={2} alignSelf="center" style={{ marginTop: "-14px" }}>
                                                          <img src={hist.dispensa.logo_Franquia === null ? showImagemFranquia : hist.dispensa.logo_Franquia}
                                                            alt={hist.dispensa.nome_Franquia}
                                                            width={80}
                                                            height={80}
                                                          />
                                                        </Grid>
                                                      </Grid>
                                                    </Grid>
                                                  </Box>
                                                </Grid>
                                              </Grid>
                                            </CardContent>
                                            {/* </CardActionArea> */}
                                          </Card>
                                        </Grid>
                                      )
                              ))
                          }
                        </Grid>
                      )
                  }
                </Grid>
              )
              : <Grid size={{ xs: 12, sm: 12 }} textAlign="initial" >
                <Typography variant="h6">Nenhuma movimentação encontrada</Typography>
                <hr />
              </Grid>
            }
            <br />
          </Grid>
        </Grid>
      </Box>
    </LayoutBaseDePagina >
  )
}


